import { Form } from 'domains/Form/Form';
import { AudioPlayerModal } from 'domains/MainPanel/components/AudioPlayer/AudioPlayerModal';
import { useSelector } from 'react-redux';
import { THEME_VARIANT } from 'shared/constants';
import {
    selectAudioUrl,
    selectFormData,
    selectIsTranscriptModal,
} from 'state/redux/slices/app';
import { MainPanelWrapper } from './MainPanel.styled';
import { columns, columnsDoctor } from './columns';
import { Table } from './components/Table/Table';
import { TranscryptionVerificationModal } from './components/TranscryptionVerificationModal/TranscryptionVerificationModal';

export const MainPanel = () => {
    const selectedAudioUrl = useSelector(selectAudioUrl);
    const selectedFormData = useSelector(selectFormData);
    const selectedIsTranscriptModal = useSelector(selectIsTranscriptModal);

    return (
        <MainPanelWrapper isDoctor={THEME_VARIANT === 'DOCTOR'}>
            <Table
                columns={THEME_VARIANT === 'DOCTOR' ? columnsDoctor : columns}
            />
            {selectedAudioUrl && <AudioPlayerModal />}
            {selectedIsTranscriptModal && <TranscryptionVerificationModal />}
            {selectedFormData && <Form />}
        </MainPanelWrapper>
    );
};
